export default __webpack_public_path__ + "static/media/timeDark.19aea2dc.svg";